import { APP_ROUTES } from '@/routes/routes.type';

const ADMIN_PATH_SEGMENT = APP_ROUTES.ADMIN_MODELS.split('/')[0];
const ADMIN_PATH_PREFIX = `/${ADMIN_PATH_SEGMENT}`;

function extractPathname(path: string): string {
  try {
    return new URL(path).pathname;
  } catch {
    return path.split('?')[0].split('#')[0];
  }
}

export function isMetrikaHostAllowed(hostname: string, allowedHosts: readonly string[]): boolean {
  const host = hostname.split(':')[0].toLowerCase();
  return allowedHosts.some((allowed) => allowed.toLowerCase() === host);
}

export function isAdminPath(path: string): boolean {
  const pathname = extractPathname(path);
  return pathname === ADMIN_PATH_PREFIX || pathname.startsWith(`${ADMIN_PATH_PREFIX}/`);
}

export function shouldTrackRoute(path: string): boolean {
  return !isAdminPath(path);
}

/** Absolute page URL for ym('hit') — Metrika reports separate SPA views more reliably. */
export function buildMetrikaPageUrl(routerPath: string, origin: string): string {
  const path = routerPath || '/';
  try {
    return new URL(path, origin).href;
  } catch {
    const normalized = path.startsWith('/') ? path : `/${path}`;
    return `${origin}${normalized}`;
  }
}
